import PropTypes from 'prop-types';
import { Button, Grid } from '@mui/material';
import { useState } from 'react';
import { HOST_API_URL } from '../../../../config-global';
import Iconify from '../../../../reusable-components/iconify';
import NewVendorModal from './NewVendorModal';
import VendorAPIModal from './VendorAPI/VendorAPIModal';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';
import { ScopeGuard } from '../../../../reusable-components/scopes';

VendorCustomToolbar.propTypes = {
  isSelecting: PropTypes.bool,
  setIsSelecting: PropTypes.func,
  selectedVendors: PropTypes.array,
  updateSelectedVendors: PropTypes.func,
  handleBulkDelete: PropTypes.func,
};
export default function VendorCustomToolbar({
  isSelecting,
  setIsSelecting,
  selectedVendors,
  updateSelectedVendors,
  handleBulkDelete,
}) {
  const [isDeleting, setIsDeleting] = useState(false);

  const onDelete = async () => {
    setIsDeleting(true);
    try {
      await handleBulkDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <Grid container direction="row" alignItems="center" sx={{ mb: 1 }}>
        <ScopeGuard scopes={['Edit-Invoice-Vendors']} allowAdmin>
          {isSelecting ? (
            <>
              <Grid item>
                <ConfirmDialog
                  button="outlined"
                  color="error"
                  disabled={selectedVendors.length === 0 || isDeleting}
                  title="Delete vendors"
                  content={`Are you sure you want to delete ${selectedVendors.length} vendor${
                    selectedVendors.length === 1 ? '' : 's'
                  }?`}
                  actionButton={isDeleting ? 'Deleting...' : 'Delete'}
                  action={onDelete}
                  manualLoading={isDeleting}
                />
              </Grid>
              <Grid item>
                <Button
                  size="small"
                  sx={{ textDecoration: 'underline' }}
                  color="secondary"
                  disabled={isDeleting}
                  onClick={() => {
                    updateSelectedVendors([]);
                    setIsSelecting(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </>
          ) : (
            <>
              <Grid item>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  sx={{ mr: 1 }}
                  startIcon={<Iconify icon="ph:check-fill" />}
                  onClick={() => {
                    updateSelectedVendors([]);
                    setIsSelecting(true);
                  }}
                >
                  Delete vendors
                </Button>
              </Grid>
              <Grid item>
                <NewVendorModal />
              </Grid>
              <Grid item>
                <VendorAPIModal />
              </Grid>
            </>
          )}
        </ScopeGuard>
        {!isSelecting && (
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              onClick={() => window.open(`${HOST_API_URL}Api/InvoiceVendors/DownloadInvoiceVendors`, '_blank')}
              startIcon={<Iconify icon="file-icons:microsoft-excel" />}
            >
              Download Invoice Vendors
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
}
